import React from "react";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { compose } from "redux";
import { reduxForm } from "redux-form";
import { getFirebase } from "react-redux-firebase";
import { getFirestore } from "redux-firestore";
import { StyledWrapper, RenderTextField, validate, history } from "@austere-monorepo/components";
import { Box, Button, Card, Grid, Typography } from "@material-ui/core";

function handleChangeEmail({ newEmail }) {
  const firebase = getFirebase();
  const firestore = getFirestore();
  return async (dispatch) => {
    try {
      await firebase.auth().currentUser.getIdToken(true);
      await firebase.auth().currentUser.updateEmail(newEmail);
      await firestore.update(
        { collection: "users", doc: firebase.auth().currentUser.uid },
        {
          email: newEmail
        }
      );
      await dispatch({
        type: "ENQUEUE_SNACKBAR",
        notification: {
          key: new Date().getTime() + Math.random(),
          message: `Email changed and confirmation sent to ${newEmail}`,
          options: {
            variant: "success"
          }
        }
      });
      await history.goBack();
    } catch (error) {
      console.log(error);
      dispatch({
        type: "ENQUEUE_SNACKBAR",
        notification: {
          key: new Date().getTime() + Math.random(),
          message: `Error changing email ` + error,
          options: {
            variant: "error"
          }
        }
      });
    }
  };
}

function EmailChangeForm(props) {
  const { handleSubmit, handleChangeEmail, pristine, submitting, error, history } = props;
  console.log(history);
  const firebase = getFirebase();
  var user = firebase.auth().currentUser;
  return (
    <form onSubmit={handleSubmit(handleChangeEmail)}>
      <StyledWrapper maxWidth={"sm"}>
        <Card>
          <Typography style={{ marginBottom: "20px" }} variant="h2" align="center">
            Change Email
          </Typography>
          <Grid container justifyContent="center" alignItems="center" spacing={3}>
            <Grid item xs={12}>
              <Typography gutterBottom>Your current email address is {user.email}</Typography>
            </Grid>
            <Field
              name="newEmail"
              label="New Email Address"
              type="email"
              placeholder="Email Address"
              component={RenderTextField}
            />

            <Grid item xs={12}>
              <Button
                fullWidth
                variant="outlined"
                color="primary"
                label="register"
                type="submit"
                disabled={submitting || error || pristine}
              >
                Change Email
              </Button>
            </Grid>

            <Grid item xs={12}>
              <Box display="flex" justifyContent="space-between">
                <Typography variant="body2" component={Link} to={"/account"}>
                  Back to My Account
                </Typography>

                <Typography variant="body2" align="center">
                  <Link t0={"/account"}>Log out</Link>
                </Typography>

                <Typography align="center" variant="body2">
                  <Link to="/help#report-issue">Report an Issue</Link>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Card>
      </StyledWrapper>
    </form>
  );
}

export default compose(
  connect(null, { handleChangeEmail }),
  reduxForm({
    form: "changeEmailForm",
    validate
  })
)(EmailChangeForm);
